import { catchError, switchMap, map } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { Observable, of as observableOf } from "rxjs";

import { Store, Action } from "@ngrx/store";
import { createEffect, Actions, ofType } from "@ngrx/effects";
import * as productActions from "./product.actions";
import { ProductService } from "./product.service";

import { State } from "../reducers";
import { Router, ActivatedRoute } from "@angular/router";

@Injectable()
export class ProductEffects {
  constructor(
    private actions$: Actions,
    private productService: ProductService,
    private store: Store<State>,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  productAllDetails;

  loadProductCategory$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(productActions.ActionTypes.LOAD_PRODUCT_CATEGORY),
      map((action: any) => action.payload),
      switchMap((payload) => {
        return this.productService
          .getProductFilters(
            payload.productSearchCriteria,
            payload.productFilters,
            payload.refreshRequired,
            payload.loadCategories
          )
          .pipe(
            map((res: any) => {
              if (res.status === 200) {
                return new productActions.LoadFilterCategoriesComplete(res);
              } else {
                this.router.navigate([
                  `https://store.nvidia.com/en-us/studio/page-not-found`,
                ]);
              }
            }),
            catchError(() =>
              observableOf(
                new productActions.LoadFilterCategoriesError({
                  message: "Failed To Load Products.123",
                })
              )
            )
          );
      })
    )
  );

  loadProductsFilter$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(productActions.ActionTypes.LOAD_PRODUCT_FILTER),
      map((action: any) => action.payload),
      switchMap((payload) => {
        return this.productService
          .getProductFilters(
            payload.productSearchCriteria,
            payload.productFilters,
            payload.refreshRequired
          )
          .pipe(
            map((res: any) => {
              if (res.status === 200) {
                return new productActions.LoadProductFiltersComplete(res);
              } else {
                this.router.navigate([
                  `https://www.nvidia.com/en-us/studio/page-not-found`,
                ]);
              }
            }),
            catchError(() =>
              observableOf(
                new productActions.LoadProductFiltersError({
                  message: "Failed To Load Products.456",
                })
              )
            )
          );
      })
    )
  );

  loadProducts$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(productActions.ActionTypes.LOAD_PRODUCT),
      map((action: any) => action.payload),
      // .switchMap(payload => { return this.productService.getProductFilters(payload.productSearchCriteria, payload.refreshRequired)})
      switchMap((payload) => {
        return this.productService
          .getProduct(
            payload.productSearchCriteria,
            payload.refreshRequired,
            payload.productFilterGroup
          )
          .pipe(
            map((res: any) => {
              if (res.status === 200) {
                this.router.navigate([`/${payload.locale}/studio/store`], {
                  relativeTo: this.route,
                  queryParams: payload.productSearchCriteria,
                });
                return new productActions.LoadProductComplete(res);
              } else {
                this.router.navigate([
                  `https://store.nvidia.com/en-us/studio/page-not-found`,
                ]);
              }
            }),
            catchError(() =>
              observableOf(
                new productActions.LoadProductError({
                  message: "Failed To Load Products.",
                })
              )
            )
          );
      })
    )
  );

  loadRetailInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(productActions.ActionTypes.LOAD_RETAIL_INFO),
      map((action: any) => action.payload),
      switchMap((payload) =>
        this.productService.getRetailInfo(payload).pipe(
          map((res: any) => {
            return new productActions.LoadRetailInfoComplete(res);
          }),
          catchError(() =>
            observableOf(
              new productActions.LoadRetailInfoError({
                message: "Failed To Load Retail Info.",
              })
            )
          )
        )
      )
    )
  );

  loadHeaderInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(productActions.ActionTypes.LOAD_HEADER_INFO),
      map((action: any) => action.payload),
      switchMap((payload) =>
        this.productService.getHeaderData(payload).pipe(
          map((res: any) => {
            return new productActions.LoadHeaderInfoComplete(res);
          }),
          catchError(() =>
            observableOf(
              new productActions.LoadHeaderInfoError({
                message: "Failed To Load Header Info.",
              })
            )
          )
        )
      )
    )
  );
}
